export default "__VITE_ASSET__DMu33$So__"